var exports = {
  "kL": "container__XZr48F",
  "Ci": "summaryBox__hErCpA",
  "_v": "chartContainer__moItqS",
  "DD": "title__crR5v8",
  "Qq": "text__EvJ4fx",
  "ko": "strong__7MNg3r",
};

module.exports = exports;
